
import { Component, Vue } from 'vue-property-decorator';

@Component({
    components: {
    }
})
export default class NedNavigatorToggle extends Vue {
    openCloseWindow() {
        this.$store.commit('setNedWindowIsOpen', !this.$store.getters.getNedWindowIsOpen);
    }
} 
